(function () {
  'use strict';
  var VAT_MULTIPLIER = 1.2;
  var MONEY_RE = /[£$€]\s?[\d,]+\.\d{2}/g;
  // .ct-cart-price covers cart-page/cart-drawer line-item prices, which use
  // Dawn's ".price"/".product-option" classes rather than ".price-item" —
  // without this, toggling Inc./Exc. VAT updated the cart's grand total but
  // left every line-item price showing the old (Exc. VAT) amount.
  var PRICE_SELECTOR = '.price-item, .totals__total-value, .unit-price, .ct-cart-price';

  // ct-vat-default-fix: the toggle intentionally does NOT persist across page
  // loads (no localStorage/sessionStorage). Every fresh page view starts in
  // 'exc' (Exc. VAT) mode — this in-memory variable only remembers the
  // customer's choice for clicks made during the current page's lifetime
  // (e.g. surviving the cart's AJAX section re-renders), not across
  // navigations or reloads. Previously this was backed by localStorage,
  // which meant a single click on Inc. VAT stuck every subsequent visit —
  // reported as "the toggle always defaults to Inc."
  var currentMode = 'exc';

  function getMode() {
    return currentMode;
  }

  function setMode(mode) {
    currentMode = mode === 'inc' ? 'inc' : 'exc';
  }

  function formatAmount(num) {
    return num.toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  // Products can be marked "don't charge tax on this product" in Shopify admin.
  // snippets/price.liquid stamps data-ct-taxable="false" on the .price wrapper for
  // those products, and the cart templates stamp the same attribute (driven by
  // item.variant.taxable) on each line's price wrapper. Anything without a
  // wrapper (cart totals, misc money elements) is treated as taxable, matching
  // Shopify's own default.
  function isTaxable(el) {
    var wrapper = el.closest ? el.closest('[data-ct-taxable]') : null;
    if (!wrapper) return true;
    return wrapper.getAttribute('data-ct-taxable') !== 'false';
  }

  // Shows/updates a small "Includes VAT (20%): £X.XX" line next to the cart's
  // grand total when Inc. VAT mode is active, so the total doesn't just change
  // silently — the customer can see how much of it is VAT. Looks for a sibling
  // .ct-vat-breakdown element next to the .totals row the total value lives in.
  function updateVatBreakdown(el, mode) {
    var totalsRow = el.closest ? el.closest('.totals') : null;
    var container = totalsRow ? totalsRow.parentElement : el.parentElement;
    var breakdown = container ? container.querySelector('.ct-vat-breakdown') : null;
    if (!breakdown) return;

    if (mode !== 'inc' || !isTaxable(el)) {
      breakdown.hidden = true;
      breakdown.textContent = '';
      return;
    }

    var origHtml = el.dataset.ctVatOrig !== undefined ? el.dataset.ctVatOrig : el.innerHTML;
    var match = origHtml.match(MONEY_RE);
    if (!match) {
      breakdown.hidden = true;
      return;
    }

    var m = match[0];
    var symbol = m.charAt(0);
    var num = parseFloat(m.replace(/[^0-9.]/g, ''));
    if (isNaN(num)) {
      breakdown.hidden = true;
      return;
    }

    var vatAmount = num * (VAT_MULTIPLIER - 1);
    breakdown.hidden = false;
    breakdown.textContent = 'Includes VAT (20%): ' + symbol + formatAmount(vatAmount);
  }

  function applyToElement(el, mode) {
    if (el.dataset.ctVatOrig === undefined) {
      el.dataset.ctVatOrig = el.innerHTML;
    }
    if (mode === 'exc' || !isTaxable(el)) {
      if (el.innerHTML !== el.dataset.ctVatOrig) el.innerHTML = el.dataset.ctVatOrig;
    } else {
      var newHtml = el.dataset.ctVatOrig.replace(MONEY_RE, function (match) {
        var symbol = match.charAt(0);
        var num = parseFloat(match.replace(/[^0-9.]/g, ''));
        if (isNaN(num)) return match;
        return symbol + formatAmount(num * VAT_MULTIPLIER);
      });
      el.innerHTML = newHtml;
    }

    if (el.classList.contains('totals__total-value')) {
      updateVatBreakdown(el, mode);
    }
  }

  function applyToAll(mode) {
    document.querySelectorAll(PRICE_SELECTOR).forEach(function (el) {
      applyToElement(el, mode);
    });
  }

  function updateSwitchUI(mode) {
    var btn = document.getElementById('ctVatSwitch');
    if (!btn) return;
    if (mode === 'inc') {
      btn.classList.add('is-inc');
      btn.setAttribute('aria-checked', 'true');
    } else {
      btn.classList.remove('is-inc');
      btn.setAttribute('aria-checked', 'false');
    }
  }

  function init() {
    var mode = getMode();
    applyToAll(mode);
    updateSwitchUI(mode);

    var btn = document.getElementById('ctVatSwitch');
    if (btn) {
      btn.addEventListener('click', function () {
        var current = getMode();
        var next = current === 'inc' ? 'exc' : 'inc';
        setMode(next);
        applyToAll(next);
        updateSwitchUI(next);
      });
    }

    var observer = new MutationObserver(function (mutations) {
      var currentModeSnapshot = getMode();
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(PRICE_SELECTOR)) {
            applyToElement(node, currentModeSnapshot);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll(PRICE_SELECTOR).forEach(function (el) {
              applyToElement(el, currentModeSnapshot);
            });
          }
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
